import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = (resource) => {
  return [
    <MenuItem primaryText='Edit' key='edit' value={`/write-now/timer_types/${resource.id}/edit`} />,
    <MenuItem primaryText='Question' key='question' value={`/write-now/questions/${resource.question_id}/edit`} />
  ]
}

export default buildMenuItems
